<div class="sidebar" [ngClass]="{ 'open': isSidebarOpen }">
    <button class="close-btn" (click)="closeSidebar()"> <img src="../../../../assets/images/cross.svg" width="20%"> </button>
    <ul class="sidebar-menu">
      <li><a routerLink="/">Home</a></li>
      <li><a routerLink="/about">About Us</a></li>
      <li><a routerLink="/contact">Contact Us</a></li>
    </ul>
</div>
  